<div
  resize-safe="1"
  class="multi-timer-panel"
  *ngIf="timerCount > 0"
  cdkDrag
  cdkDragBoundary="body"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded()"
>
  <!-- Panel Header -->
  <div class="panel-header" (click)="toggleCollapse()" cdkDragHandle>
    <div class="header-left">
      <div class="header-brand">
        <span class="header-icon">
          <i class="ri-time-line"></i>
        </span>
        <div class="header-copy">
          <span class="timer-count"
            >{{ timerCount }} Active Timer{{ timerCount > 1 ? "s" : "" }}</span
          >
          <span class="timer-caption">Live task tracking panel</span>
        </div>
      </div>

      <div class="header-statuses">
        <span class="timer-status running" *ngIf="runningCount > 0">
          <i class="ri-circle-fill running-indicator"></i>
          <span class="status-count">{{ runningCount }}</span>
          <span class="status-label">Running</span>
        </span>
        <span class="timer-status paused" *ngIf="pausedCount > 0">
          <i class="ri-pause-circle-line paused-indicator"></i>
          <span class="status-count">{{ pausedCount }}</span>
          <span class="status-label">Paused</span>
        </span>
      </div>
    </div>
    <div class="header-actions" (mousedown)="$event.stopPropagation()">
      <!-- View Mode Toggle (only show if multiple timers) -->
      <button
        *ngIf="timerCount > 1"
        type="button"
        class="header-btn"
        (click)="toggleViewMode(); $event.stopPropagation()"
        [pTooltip]="
          viewMode === 'single' ? 'Show all timers' : 'Show single timer'
        "
        tooltipPosition="top"
        tooltipStyleClass="timer-panel-tooltip"
      >
        <i
          class="pi"
          [ngClass]="viewMode === 'single' ? 'pi-th-large' : 'pi-list'"
        ></i>
      </button>
      <button
        type="button"
        class="header-btn collapse-btn"
        (click)="toggleCollapse(); $event.stopPropagation()"
        [pTooltip]="isCollapsed ? 'Expand panel' : 'Collapse panel'"
        tooltipPosition="top"
        tooltipStyleClass="timer-panel-tooltip"
      >
        <i
          class="pi"
          [ngClass]="isCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'"
        ></i>
      </button>
    </div>
  </div>

  <!-- Panel Body -->
  <div class="panel-body" [class.collapsed]="isCollapsed">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading timers...</span>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && timers.length === 0" class="empty-state">
      <i class="ri-time-line"></i>
      <span>No active timers</span>
    </div>

    <!-- Timer List -->
    <div *ngIf="!isLoading && timers.length > 0" class="timer-list">
      <div
        *ngFor="let timer of displayedTimers; trackBy: trackByTimerId"
        class="timer-item"
        [class.running]="timer.status === 'RUNNING'"
        [class.paused]="timer.status === 'PAUSED'"
      >
        <div class="timer-top">
          <div class="timer-info" (mousedown)="$event.stopPropagation()">
            <div class="task-name" (click)="onNavigateToTask(timer, $event)">
              {{ timer.taskName }}
            </div>
            <div class="project-row" (click)="onNavigateToProject(timer, $event)">
              <i class="ri-briefcase-4-line"></i>
              <span class="project-name">{{ timer.projectName }}</span>
            </div>
          </div>

          <div
            class="timer-display"
            [ngClass]="timer.status === 'RUNNING' ? 'running' : 'paused'"
          >
            <span class="time">{{ timer.elapsedTime | formatTime }}</span>
          </div>
        </div>

        <div class="timer-footer">
          <div
            class="status-pill"
            [ngClass]="timer.status === 'RUNNING' ? 'running' : 'paused'"
          >
            <i
              *ngIf="timer.status === 'RUNNING'"
              class="ri-circle-fill status-indicator running"
            ></i>
            <i
              *ngIf="timer.status === 'PAUSED'"
              class="ri-pause-circle-line status-indicator paused"
            ></i>
            <span>{{ timer.status === "RUNNING" ? "Running" : "Paused" }}</span>
          </div>

          <div class="timer-actions" (mousedown)="$event.stopPropagation()">
            <!-- Show detail view button in single view mode (before other actions) -->
            <button
              *ngIf="viewMode === 'single' && timerCount > 1"
              type="button"
              class="action-btn detail-btn"
              (click)="toggleViewMode(); $event.stopPropagation()"
              pTooltip="Show all timers"
              tooltipPosition="top"
              tooltipStyleClass="timer-panel-tooltip"
            >
              <i class="pi pi-th-large"></i>
            </button>

            <button
              *ngIf="timer.status === 'RUNNING'"
              type="button"
              class="action-btn pause-btn"
              (click)="onPauseTimer(timer, $event)"
              pTooltip="Pause"
              tooltipPosition="top"
              tooltipStyleClass="timer-panel-tooltip"
            >
              <i class="ri-pause-circle-line"></i>
            </button>
            <button
              *ngIf="timer.status === 'PAUSED'"
              type="button"
              class="action-btn resume-btn"
              (click)="onResumeTimer(timer, $event)"
              pTooltip="Resume"
              tooltipPosition="top"
              tooltipStyleClass="timer-panel-tooltip"
            >
              <i class="ri-play-circle-line"></i>
            </button>
            <button
              type="button"
              class="action-btn stop-btn"
              (click)="onStopTimer(timer, $event)"
              pTooltip="Stop"
              tooltipPosition="top"
              tooltipStyleClass="timer-panel-tooltip"
            >
              <i class="ri-stop-circle-line"></i>
            </button>
            <button
              type="button"
              class="action-btn edit-btn"
              (click)="onEditTimer(timer, $event)"
              pTooltip="Edit timer"
              tooltipPosition="top"
              tooltipStyleClass="timer-panel-tooltip"
            >
              <i class="pi pi-pencil"></i>
            </button>
            <button
              type="button"
              class="action-btn delete-btn"
              (click)="onDeleteTimer(timer, $event)"
              pTooltip="Delete timer"
              tooltipPosition="top"
              tooltipStyleClass="timer-panel-tooltip"
            >
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Timer Modal -->
<app-edit-timer-modal
  [(visible)]="showEditTimerModal"
  [timer]="selectedTimer"
  (onSave)="handleTimerUpdate($event)"
></app-edit-timer-modal>

<!-- Confirmation Dialog -->
<p-confirmDialog
  [baseZIndex]="999999"
  [autoZIndex]="true"
  [style]="{ width: '450px' }"
></p-confirmDialog>
